<template>
  <div class="wap-page">
    <div
      style="
        padding: 30px 10px 50px;
        background: linear-gradient(to right,rgb(9, 32, 55),rgb(20, 79, 138),rgb(9, 32, 55));
        text-align: center;
        line-height: 1.5;
      "
    >
      <img src="../../assets/user.png" style="width: 80px; height: 80px" />
      <p>{{ usr.username }}</p>
      <p>ID:{{ usr.id }}</p>
    </div>
    <div>
      <div
        style="
          border-radius: 10px;
          padding: 10px 20px;
          line-height: 1.5;
          border: 1px solid rgb(12, 40, 68);
          background: rgb(39, 76, 114);
          box-shadow: rgb(6, 23, 35) 0px 0px 15px 0px;
          width: 90%;
          margin: -40px auto 0;
        "
      >
        <p>{{ $t('assets.allconvert') }} （{{ $t('common.unit') }}）</p>
        <p style="color: rgb(0, 230, 255); font-size: 20px">
          <span style="font-size: 14px">&#8776;</span>0.00
        </p>
        <van-row style="width: 100%; margin-top: 15px; font-size: 14px">
          <van-col :span="12">
            <div>{{ $t('other.yingli') }}:</div>
            <p style="color: rgb(6, 255, 0)">
              &#8776; {{ parseFloat(accountData.win_price).toFixed(2) }} {{ $t('common.unit') }}
            </p>
          </van-col>
          <van-col :span="12">
            <div>{{ $t('other.kuisun') }}:</div>
            <p style="color: rgb(254, 140, 140)">
              &#8776; {{ parseFloat(accountData.lose_price).toFixed(2) }} {{ $t('common.unit') }}
            </p>
          </van-col>
        </van-row>
        <van-row style="text-align: center; font-size: 14px;margin-top: 10px;">
          <van-col :span="8" v-for="(item, index) in items" :key="index" @click="toPage(item.key)">
            <img
              :src="require('@/assets/trade/' + item.key + '.png')"
              style="width: 32px"
            />
            <p>{{ item.value }}</p>
          </van-col>
        </van-row>
      </div>
    </div>
    <div style="width: 86%;margin: 20px auto;line-height: 3;font-size: 18px;">
      <ul style="font-size: 14px;">
        <li  v-for="(item, index) in tabs" style="border-bottom: 1px solid rgb(139, 151, 160);"
        :key="index" @click="toshow(index)">
        <svg-icon icon-class="depositpwd" v-if="item.key == 1" style="font-size: 24px;margin-right: -5px;" />
        <svg-icon icon-class="market" v-else />
        &nbsp;{{ item.name }}</li>
      <li @click="toPage('trade-account')" style="border-bottom: 1px solid rgb(139, 151, 160);"><svg-icon icon-class="options" />&nbsp; {{ $t('assets.tbhead1') }}</li>
      <li>
        <div style="float: left;"><van-icon name="eye-o" /></div> 
        <div style="float: left;margin-left: 4px;">{{ $t('member.night_mode') }}</div>
        <div  style="float: left;margin-left: 4px;"><van-switch v-model="checked" size="18px" style="margin-top: 12px;" @click="changeTheme" /></div>
      </li>
      <li style="clear: both;" />
      <li style="display: none;"><svg-icon icon-class="options" />&nbsp; {{ $t('assets.tbhead2') }}</li>
      <li style="display: none;"><svg-icon icon-class="options" />&nbsp; {{ $t('assets.tbhead3') }}</li>
      </ul>
    </div>
    <div style="margin: 30px 16px 16px 16px;">
    <van-button block type="info" @click="LogOut">{{ $t('member.log_out') }}</van-button>
  </div>
    <van-popup v-model="show" :style="{ height: '100vh',width: '100vw' }" :closeable="true">
      <div style="background-color: #000;">
      <AssetInfo
            :title="getTypeName(item.key)"
            :isopen="isopen"
            :num="parseFloat(item.money).toFixed(8)"
            :nums="parseFloat(item.money).toFixed(2)"
            @child-event="changeOpen"
          />
          <div
            style="
              margin-top: 5px;
              overflow-y: auto;
              height: calc(100vh - 135px);
            "
          >
            <AssetItem
              v-for="(subitem, subindex) in item.data"
              :key="subindex"
              :typeName="subitem.coinName"
              :typeId="item.key"
              :isopen="isopen"
              :useNum="parseFloat(subitem.balance).toFixed(8)"
              :freezeNum="parseFloat(subitem.dbalance).toFixed(8)"
              :conversion="parseFloat(subitem.all_zhprice).toFixed(2)"
              :link="subitem.coinId"
            />
          </div>
          </div>
    </van-popup>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer/index.vue'
import { AssetItem, AssetInfo } from './components/index'
import {
  removeToken,
  TokenColorKey,
  setTokenbyName,
  getTokenbyName
} from '@/utils/cookies'
export default {
  name: 'AssetsView',
  components: { Footer, AssetItem, AssetInfo },
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  data () {
    return {
      active: null,
      isopen: true,
      accountData: {},
      tabs: [],
      assets: [],
      usr: {},
      active1: 'home',
      items: [
        { key: 'recharge', value: this.$t('footer.recharge') },
        { key: 'withdrawal', value: this.$t('footer.withdrawal') },
        { key: 'changemoney', value: this.$t('footer.change') }
      ],
      show:false,
      item:{},
      checked:true
    }
  },
  mounted () {
    this.checked = getTokenbyName(TokenColorKey) == "night";
    this.getMemberInf()
    this.getUserBalanceList()
  },
  methods: {
     changeTheme() {
      if (this.checked) {
        setTokenbyName(TokenColorKey, "day");
        document.documentElement.style.setProperty(
          "--background-color",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--background-color1",
          "#e1e1ea"
        );
        document.documentElement.style.setProperty("--font-color", "#000");
      } else {
        setTokenbyName(TokenColorKey, "night");
        document.documentElement.style.setProperty(
          "--background-color",
          "#102030"
        );
        document.documentElement.style.setProperty(
          "--background-color1",
          "#0b1622"
        );
        document.documentElement.style.setProperty("--font-color", "#fff");
      }
    },
    async getMemberInf () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        this.usr = res.data
      })
    },
    changeOpen () {
      this.isopen = !this.isopen
    },
    async getUserBalanceList () {
      await this.$http({
        method: 'post',
        url: 'getUserBalanceList'
      }).then(res => {
        if (res && res.data) this.accountData = res.data
        this.IntegrationData()
      })
    },
    IntegrationData () {
      //this.assets.push({
      //  name: this.$t('assets.tab11'),
      //  money: parseFloat(this.accountData.all_price).toFixed(2)
      //})
      //this.tabs.push({ name: this.$t('assets.tab1'), key: 0 })
      this.accountData.coinList.forEach(item => {
        this.tabs.push({
          name: this.getTabName(item.type),
          key: item.type,
          money: parseFloat(item.totalAvailableAsset).toFixed(2),
          data: item.balanceInfo
        })
        this.assets.push({
          name: this.getTypeName(item.type),
          money: parseFloat(item.totalAvailableAsset).toFixed(2)
        })
      })
      //this.tabs[0].data = this.assets
    },
    getTypeName (val) {
      let result = val
      switch (val) {
        case 2:
          result = this.$t('assets.tab12')
          break
        case 1:
          result = this.$t('assets.tab13')
          break
        case 3:
          result = this.$t('assets.tab14')
          break
        default:
          break
      }
      return result
    },
    getTabName (val) {
      let result = val
      switch (val) {
        case 2:
          result = this.$t('assets.tab2')
          break
        case 1:
          result = this.$t('assets.tab3')
          break
        case 3:
          result = this.$t('assets.tab4')
          break
        default:
          break
      }
      return result
    },
    toPage (item) {
      if (item == 'recharge' && this.safeWapConfig.recharge_status != 1) {
        if (this.safeWapConfig.custom_service.length > 0) {
          this.jumpUrl(this.safeWapConfig.custom_service)
          return
        } else {
          this.$toast.fail(this.$t('common.forserver'))
          return
        }
      }
      if (
        item == 'withdrawal' &&
        this.safeWapConfig.withdrawal_status != 1
      ) {
        if (this.safeWapConfig.custom_service.length > 0) {
          this.jumpUrl(this.safeWapConfig.custom_service)
          return
        } else {
          this.$toast.fail(this.$t('common.forserver'))
          return
        }
      }
      this.$router.push({ name: item }, () => {})
    },
    jumpUrl (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
      return
      /*
      const _u = navigator.userAgent;
      const ios = _u.indexOf("iPhone") > -1;
      const iPad = _u.indexOf("iPad") > -1;
      if (ios || iPad) {
        window.location.replace(url);
      } else {
        if (url.includes("https://")) {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
        */
    },
    toshow(key){
      this.item = this.tabs[key]
      this.show = true
    },
     async LogOut () {
      this.$emit('close-left')
      await this.$http({
        method: 'post',
        url: 'logout'
      }).then(() => {})
      removeToken()
      location.reload()
    }
  }
}
</script>

<style></style>
